import { AUDIT_LOGS_LOAD, AUDIT_LOGS_UNLOAD } from "../constants/actionTypes";

const defaultPage = { content: [], number: 0, size: 20, totalElements: 0, totalPages: 0 };

export default (state = { logs: defaultPage }, action) => {
    switch (action.type) {
        case AUDIT_LOGS_LOAD: {
            const p = action.payload;
            let normalized;
            if (Array.isArray(p)) {
                normalized = { ...defaultPage, content: p, totalElements: p.length, number: 0 };
            } else if (p && typeof p === 'object') {
                const content = Array.isArray(p.content) ? p.content : (Array.isArray(p.items) ? p.items : []);
                const totalElements = typeof p.totalElements === 'number' ? p.totalElements : (typeof p.total === 'number' ? p.total : content.length);
                const size = typeof p.size === 'number' ? p.size : (typeof p.pageSize === 'number' ? p.pageSize : defaultPage.size);
                const number = typeof p.number === 'number' ? p.number : (typeof p.pageNumber === 'number' ? p.pageNumber : (typeof p.page === 'number' ? p.page : 0));
                const totalPages = typeof p.totalPages === 'number' ? p.totalPages : (size > 0 ? Math.ceil(totalElements / size) : 0);
                normalized = { content, totalElements, size, number, totalPages };
            } else {
                normalized = defaultPage;
            }
            return { ...state, logs: normalized };
        }
        case AUDIT_LOGS_UNLOAD:
            return { ...state, logs: defaultPage };
        default:
            return state;
    }
};
